/**
 * Section Label
 *
 * Small uppercase eyebrow that headers each board-drawer section (Subtasks,
 * Comments, Activity, Feature flags, …). Shared across board drawers.
 *
 * @module features/cards/components/SectionLabel
 */

import React from 'react';

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <span className="text-[11px] font-semibold uppercase tracking-wider text-foreground/55">
      {children}
    </span>
  );
}
